var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * CZNA-1422 — the ⋮ menu at the end of a subfield row: the actions over that
 * one row: "Posunout nahoru", "Posunout dolů" and, since CZNA-1449, "Vložit
 * podpole za" — the same as Alt+Enter from the row's input — and, since
 * CZNA-1515, "Odebrat podpole" on a row the cataloguer may take out again.
 *
 * <p>A Stripes `Dropdown`, so the keyboard comes with it: Enter or ArrowDown
 * on the trigger opens it, the arrows walk the items, Enter chooses, Escape
 * closes. An item that cannot run is `disabled`, which also takes it out of
 * the arrow walk.
 */
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Dropdown, DropdownMenu, IconButton } from '@folio/stripes/components';
import dropdownTriggerFocus from '../../../utils/dropdownTriggerFocus';
var SubfieldRowMenu = function (_a) {
    var id = _a.id, label = _a.label, canMoveUp = _a.canMoveUp, canMoveDown = _a.canMoveDown, onMove = _a.onMove, onInsert = _a.onInsert, onRemove = _a.onRemove;
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    var choose = function (delta) { return function () {
        setOpen(false);
        onMove(delta);
    }; };
    return (React.createElement(Dropdown, { id: "".concat(id, "-dropdown"), open: open, 
        // The opposite of what this render shows, not a flip of the latest state:
        // a click on the trigger of an open menu is also a click outside it, and
        // DropdownMenu's capture-phase listener closes it first — a flip would
        // reopen it.
        onToggle: function () { return setOpen(!open); }, placement: "bottom-end", renderTrigger: function (_a) {
            var getTriggerProps = _a.getTriggerProps, triggerRef = _a.triggerRef, onToggle = _a.onToggle, ariaProps = _a.ariaProps, keyHandler = _a.keyHandler;
            return (React.createElement(IconButton, __assign({ ref: triggerRef, id: id, icon: "ellipsis", size: "small", onClick: onToggle, onKeyDown: keyHandler }, dropdownTriggerFocus(getTriggerProps), { "aria-label": label }, ariaProps, { 
                // Popdown's `aria-expanded` is a boolean, which IconButton drops when false.
                ariaExpanded: String(open) })));
        } },
        React.createElement(DropdownMenu, { "aria-label": label, open: open, onToggle: function () { return setOpen(false); } },
            React.createElement("div", { role: "menu" },
                React.createElement(Button, { buttonStyle: "dropdownItem", role: "menuitem", disabled: !canMoveUp, onClick: choose(-1) },
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.proposalForm.subfieldRow.moveUp" })),
                React.createElement(Button, { buttonStyle: "dropdownItem", role: "menuitem", disabled: !canMoveDown, onClick: choose(1) },
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.proposalForm.subfieldRow.moveDown" })),
                onInsert && (React.createElement(Button, { buttonStyle: "dropdownItem", role: "menuitem", onClick: function () {
                        setOpen(false);
                        onInsert();
                    } },
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.proposalForm.subfieldRow.insertAfter" }))),
                onRemove && (React.createElement(Button, { buttonStyle: "dropdownItem", role: "menuitem", onClick: function () {
                        setOpen(false);
                        onRemove();
                    } },
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.proposalForm.subfieldRow.remove" })))))));
};
export default SubfieldRowMenu;
